import type { PlatformProfile } from '@/api/platform.api';

/**
 * Roles that may open the Platform Console. The API's own list (PlatformRoleNames) is SuperAdmin,
 * PlatformAdmin and SupportAdmin; BillingAdmin and PlatformManager are accepted here so the console
 * admits them the day the API seeds them.
 *
 * This is the screen's gate, not the security boundary: every /api/platform endpoint is
 * [PlatformAuthorize] and refuses a tenant token whatever this says.
 */
export const PLATFORM_ROLES = ['SuperAdmin', 'PlatformAdmin', 'SupportAdmin', 'BillingAdmin', 'PlatformManager'];

const ALLOWED = new Set(PLATFORM_ROLES.map((r) => r.toLowerCase()));

/** A platform user (UserType "Platform") holding at least one platform role. */
export function hasPlatformAccess(profile: PlatformProfile | null | undefined): boolean {
  if (!profile || profile.userType?.toLowerCase() !== 'platform') return false;
  return (profile.roles ?? []).some((role) => ALLOWED.has(role.toLowerCase()));
}
